<template>
    <Modal id="insurance-modal"
           size="lg"
           :centered="true"
           :show="show"
           v-on="$listeners"
    >
        <div v-if="insurance" class="pt-6 px-4 px-md-6 text-center">
            <h2 class="h1 font-weight-semibold position-relative mb-5 text-center"
                v-html="insurance.title.rendered"
            >
            </h2>
            <div class="text-justify"
                 v-html="insurance.content.rendered">
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import {mapGetters} from "vuex";

export default {
    name: "InsuranceModal",
    components: {Modal},
    props: {
        show: {
            default: false,
            type: Boolean,
        }
    },
    computed: {
        ...mapGetters({
            insurance: 'terms/insurance'
        })
    }
}
</script>